import React from 'react';

export const PlayIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    role="img"
    aria-labelledby="Play"
  >
    <title id="Play">Play the background video.</title>
    <path
      d="M30.5746 22.9378C29.5927 22.2832 28.3302 22.2222 27.2897 22.779C26.2492 23.3359 25.5996 24.4202 25.5996 25.6004V38.4004C25.5996 39.5805 26.2492 40.6649 27.2897 41.2217C28.3302 41.7786 29.5927 41.7176 30.5746 41.063L40.1746 34.663C41.0649 34.0695 41.5996 33.0703 41.5996 32.0004C41.5996 30.9305 41.0649 29.9313 40.1746 29.3378L30.5746 22.9378Z"
      fill="white"
    />
  </svg>
);

export const PauseIcon = (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby="Pause"
  >
    <title id="Pause">Pause the background video.</title>
    <path
      d="M22.4004 25.6C22.4004 23.8327 23.8331 22.4 25.6004 22.4C27.3677 22.4 28.8004 23.8327 28.8004 25.6V38.4C28.8004 40.1673 27.3677 41.6 25.6004 41.6C23.8331 41.6 22.4004 40.1673 22.4004 38.4V25.6ZM38.4004 22.4C36.6331 22.4 35.2004 23.8327 35.2004 25.6V38.4C35.2004 40.1673 36.6331 41.6 38.4004 41.6C40.1677 41.6 41.6004 40.1673 41.6004 38.4V25.6C41.6004 23.8327 40.1677 22.4 38.4004 22.4Z"
      fill="white"
    />
  </svg>
);

export const ArrowDownIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12.92"
    height="7.27"
    viewBox="0 0 16 9"
    fill="none"
  >
    <path
      d="M16 0.999794C16 1.26563 15.891 1.51496 15.7028 1.7032L8.70341 8.70258C8.516 8.88999 8.26584 8.99979 8 8.99979C7.73416 8.99979 7.48483 8.89082 7.29659 8.70258L0.297214 1.7032C0.109804 1.51579 0 1.26563 0 0.999794C0 0.453251 0.453251 0 0.999794 0H14.9986C15.5451 0 15.9983 0.453251 15.9983 0.999794H16Z"
      fill="black"
    />
  </svg>
);

export const CaretDown = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.8991 9.39714L12.3991 16.8971C12.2936 17.0025 12.1507 17.0616 12.0016 17.0616C11.8525 17.0616 11.7096 17.0025 11.6041 16.8971L4.10409 9.39714C4.00473 9.29051 3.95064 9.14948 3.95321 9.00375C3.95578 8.85802 4.01482 8.71898 4.11788 8.61592C4.22094 8.51287 4.35998 8.45383 4.5057 8.45126C4.65143 8.44869 4.79246 8.50278 4.89909 8.60214L12.0016 15.7037L19.1041 8.60214C19.2107 8.50278 19.3518 8.44869 19.4975 8.45126C19.6432 8.45383 19.7823 8.51287 19.8853 8.61592C19.9884 8.71898 20.0474 8.85802 20.05 9.00375C20.0525 9.14948 19.9985 9.29051 19.8991 9.39714Z"
      fill="currentColor"
    />
  </svg>
);

export const PlusGlyph = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="black"
  >
    <rect x="8" width="1" height="17" />
    <rect x="17" y="8" width="1" height="17" transform="rotate(90 17 8)" />
  </svg>
);

export const CirclePlayIcon = (
  <svg
    width="103"
    height="104"
    viewBox="0 0 103 104"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      y="0.876465"
      width="103"
      height="103"
      rx="51.5"
      fill="#F4F1E4"
      fillOpacity="0.8"
    />
    <path
      d="M77 52.6294L36.1206 76.2311L36.1206 29.0277L77 52.6294Z"
      fill="url(#paint0_linear_7251_18536)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7251_18536"
        x1="18.1158"
        y1="72.3218"
        x2="44.703"
        y2="16.6707"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0F2830" />
        <stop offset="1" stopColor="#014751" />
      </linearGradient>
    </defs>
  </svg>
);

export const CSVIcon = (
  <svg
    width="63"
    height="64"
    viewBox="0 0 63 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.75 7C6.75 3.54822 9.54822 0.75 13 0.75H38L56.75 19.5V57C56.75 60.4518 53.9518 63.25 50.5 63.25H13C9.54822 63.25 6.75 60.4518 6.75 57V7Z"
      fill="url(#paint0_linear_7251_23364)"
    />
    <path
      opacity="0.3"
      d="M38 0.75L56.75 19.5H44.25C40.7982 19.5 38 16.7018 38 13.25V0.75Z"
      fill="#0B0B0B"
    />
    <path
      d="M24.911 46.371H26.9641C26.9229 47.0439 26.7375 47.6413 26.4079 48.1631C26.0829 48.685 25.6274 49.0924 25.0415 49.3854C24.4601 49.6783 23.7597 49.8248 22.9403 49.8248C22.2995 49.8248 21.725 49.715 21.2169 49.4952C20.7087 49.2709 20.2739 48.9505 19.9122 48.5339C19.5552 48.1174 19.2828 47.6138 19.0951 47.0233C18.9074 46.4328 18.8136 45.7713 18.8136 45.0389V44.3454C18.8136 43.613 18.9097 42.9515 19.102 42.361C19.2988 41.7659 19.5781 41.2601 19.9397 40.8435C20.3059 40.4269 20.7431 40.1065 21.2512 39.8822C21.7593 39.6579 22.3269 39.5457 22.9541 39.5457C23.7872 39.5457 24.4899 39.6968 25.0621 39.9989C25.6389 40.3011 26.0852 40.7176 26.401 41.2486C26.7215 41.7796 26.9137 42.3839 26.9778 43.0614H24.9179C24.895 42.6585 24.8149 42.3175 24.6776 42.0383C24.5402 41.7545 24.3319 41.5416 24.0527 41.3997C23.778 41.2532 23.4118 41.18 22.9541 41.18C22.6107 41.18 22.3109 41.244 22.0546 41.3722C21.7982 41.5004 21.5831 41.6949 21.4091 41.9559C21.2352 42.2168 21.1047 42.5464 21.0177 42.9446C20.9353 43.3383 20.8941 43.8007 20.8941 44.3317V45.0389C20.8941 45.5562 20.933 46.0117 21.0109 46.4053C21.0887 46.7944 21.2077 47.124 21.3679 47.3941C21.5327 47.6596 21.7433 47.861 21.9996 47.9984C22.2606 48.1311 22.5741 48.1975 22.9403 48.1975C23.3706 48.1975 23.7254 48.1288 24.0046 47.9915C24.2839 47.8542 24.4967 47.6505 24.6432 47.3804C24.7943 47.1103 24.8835 46.7738 24.911 46.371ZM33.5215 47.0714C33.5215 46.8929 33.4941 46.7326 33.4391 46.5907C33.3888 46.4442 33.2927 46.3115 33.1508 46.1925C33.0089 46.0689 32.8097 45.9476 32.5534 45.8286C32.297 45.7095 31.9651 45.5859 31.5577 45.4578C31.1046 45.3113 30.6743 45.1465 30.2668 44.9634C29.864 44.7803 29.507 44.5674 29.1957 44.3248C28.889 44.0776 28.6464 43.7915 28.4678 43.4665C28.2939 43.1415 28.2069 42.7638 28.2069 42.3335C28.2069 41.917 28.2985 41.5393 28.4816 41.2006C28.6647 40.8572 28.921 40.5643 29.2506 40.3217C29.5802 40.0745 29.9693 39.8845 30.4179 39.7517C30.8711 39.619 31.3678 39.5526 31.9079 39.5526C32.6449 39.5526 33.2881 39.6854 33.8374 39.9509C34.3867 40.2164 34.8124 40.5803 35.1146 41.0426C35.4213 41.505 35.5746 42.0337 35.5746 42.6288H33.5284C33.5284 42.3358 33.4666 42.0795 33.343 41.8597C33.224 41.6354 33.0409 41.4592 32.7937 41.331C32.5511 41.2029 32.2444 41.1388 31.8736 41.1388C31.5165 41.1388 31.219 41.1937 30.981 41.3036C30.7429 41.4088 30.5644 41.553 30.4454 41.7361C30.3264 41.9147 30.2668 42.1161 30.2668 42.3404C30.2668 42.5098 30.308 42.6631 30.3904 42.8004C30.4774 42.9378 30.6056 43.0659 30.775 43.185C30.9443 43.304 31.1526 43.4161 31.3998 43.5214C31.647 43.6267 31.9331 43.7297 32.2581 43.8304C32.8029 43.9952 33.2812 44.1806 33.6932 44.3866C34.1098 44.5926 34.4577 44.8238 34.7369 45.0801C35.0161 45.3365 35.2267 45.6271 35.3686 45.9521C35.5105 46.2772 35.5815 46.6457 35.5815 47.0576C35.5815 47.4925 35.4968 47.8816 35.3274 48.2249C35.1581 48.5683 34.9131 48.8589 34.5927 49.097C34.2723 49.335 33.89 49.5158 33.446 49.6394C33.002 49.763 32.5053 49.8248 31.956 49.8248C31.4616 49.8248 30.9741 49.7607 30.4934 49.6326C30.0128 49.4998 29.5756 49.3007 29.1819 49.0352C28.7928 48.7697 28.4816 48.4309 28.2481 48.019C28.0146 47.607 27.8979 47.1194 27.8979 46.5564H29.9647C29.9647 46.8677 30.0128 47.1309 30.1089 47.346C30.205 47.5612 30.3401 47.7351 30.514 47.8679C30.6926 48.0006 30.9031 48.0968 31.1458 48.1563C31.3929 48.2158 31.663 48.2455 31.956 48.2455C32.313 48.2455 32.606 48.1952 32.8349 48.0945C33.0684 47.9938 33.24 47.8542 33.3499 47.6756C33.4643 47.4971 33.5215 47.2957 33.5215 47.0714ZM40.5871 47.6001L42.9423 39.6899H45.2357L41.7544 49.6875H40.2438L40.5871 47.6001ZM38.4173 39.6899L40.7657 47.6001L41.1227 49.6875H39.5984L36.1377 39.6899H38.4173Z"
      fill="#0B0B0B"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7251_23364"
        x1="58.3629"
        y1="89.9032"
        x2="-20.3749"
        y2="48.924"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#AFF8C8" />
        <stop offset="1" stopColor="#6E8F95" />
      </linearGradient>
    </defs>
  </svg>
);

export const DOCIcon = (
  <svg
    width="63"
    height="64"
    viewBox="0 0 63 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.75 7C6.75 3.54822 9.54822 0.75 13 0.75H38L56.75 19.5V57C56.75 60.4518 53.9518 63.25 50.5 63.25H13C9.54822 63.25 6.75 60.4518 6.75 57V7Z"
      fill="url(#paint0_linear_7251_23361)"
    />
    <path
      opacity="0.3"
      d="M38 0.75L56.75 19.5H44.25C40.7982 19.5 38 16.7018 38 13.25V0.75Z"
      fill="white"
    />
    <path
      d="M21.6906 49.6875H19.514L19.5277 48.0807H21.6906C22.2308 48.0807 22.6863 47.9594 23.0571 47.7168C23.4279 47.4696 23.7071 47.1103 23.8948 46.6388C24.087 46.1673 24.1832 45.5974 24.1832 44.929V44.4415C24.1832 43.9288 24.1282 43.4779 24.0184 43.0888C23.9131 42.6997 23.7552 42.3724 23.5446 42.1069C23.334 41.8414 23.0754 41.6423 22.7687 41.5096C22.462 41.3722 22.1095 41.3036 21.7112 41.3036H19.4728V39.6899H21.7112C22.3796 39.6899 22.9907 39.8044 23.5446 40.0333C24.1031 40.2576 24.586 40.5803 24.9934 41.0014C25.4008 41.4226 25.7144 41.9261 25.9341 42.5121C26.1584 43.0934 26.2706 43.7411 26.2706 44.4553V44.929C26.2706 45.6386 26.1584 46.2863 25.9341 46.8723C25.7144 47.4582 25.4008 47.9617 24.9934 48.3829C24.5906 48.7994 24.1076 49.1222 23.5446 49.351C22.9861 49.5753 22.3681 49.6875 21.6906 49.6875ZM20.6813 39.6899V49.6875H18.6213V39.6899H20.6813ZM35.9797 44.4553V44.929C35.9797 45.6889 35.8767 46.371 35.6707 46.9753C35.4648 47.5795 35.1741 48.0945 34.7987 48.5202C34.4233 48.9413 33.9747 49.2641 33.4529 49.4884C32.9356 49.7127 32.3611 49.8248 31.7294 49.8248C31.1023 49.8248 30.5278 49.7127 30.0059 49.4884C29.4886 49.2641 29.04 48.9413 28.6601 48.5202C28.2802 48.0945 27.9849 47.5795 27.7743 46.9753C27.5683 46.371 27.4653 45.6889 27.4653 44.929V44.4553C27.4653 43.6908 27.5683 43.0087 27.7743 42.4091C27.9803 41.8048 28.271 41.2898 28.6464 40.8641C29.0263 40.4384 29.4749 40.1134 29.9922 39.8891C30.514 39.6648 31.0885 39.5526 31.7157 39.5526C32.3474 39.5526 32.9219 39.6648 33.4391 39.8891C33.961 40.1134 34.4096 40.4384 34.785 40.8641C35.1649 41.2898 35.4579 41.8048 35.6639 42.4091C35.8745 43.0087 35.9797 43.6908 35.9797 44.4553ZM33.8992 44.929V44.4415C33.8992 43.9105 33.8511 43.4436 33.755 43.0408C33.6589 42.6379 33.517 42.2992 33.3293 42.0245C33.1416 41.7499 32.9127 41.5439 32.6426 41.4066C32.3726 41.2646 32.0636 41.1937 31.7157 41.1937C31.3678 41.1937 31.0588 41.2646 30.7887 41.4066C30.5232 41.5439 30.2966 41.7499 30.1089 42.0245C29.9258 42.2992 29.7862 42.6379 29.6901 43.0408C29.5939 43.4436 29.5459 43.9105 29.5459 44.4415V44.929C29.5459 45.4555 29.5939 45.9224 29.6901 46.3298C29.7862 46.7326 29.9281 47.0737 30.1158 47.3529C30.3035 47.6276 30.5323 47.8358 30.8024 47.9778C31.0725 48.1197 31.3815 48.1906 31.7294 48.1906C32.0773 48.1906 32.3863 48.1197 32.6564 47.9778C32.9265 47.8358 33.153 47.6276 33.3362 47.3529C33.5193 47.0737 33.6589 46.7326 33.755 46.3298C33.8511 45.9224 33.8992 45.4555 33.8992 44.929ZM43.2582 46.371H45.3112C45.2701 47.0439 45.0847 47.6413 44.7551 48.1631C44.4301 48.685 43.9746 49.0924 43.3886 49.3854C42.8073 49.6783 42.1069 49.8248 41.2875 49.8248C40.6466 49.8248 40.0721 49.715 39.564 49.4952C39.0559 49.2709 38.621 48.9505 38.2594 48.5339C37.9023 48.1174 37.63 47.6138 37.4423 47.0233C37.2546 46.4328 37.1608 45.7713 37.1608 45.0389V44.3454C37.1608 43.613 37.2569 42.9515 37.4492 42.361C37.646 41.7659 37.9252 41.2601 38.2869 40.8435C38.6531 40.4269 39.0902 40.1065 39.5984 39.8822C40.1065 39.6579 40.6741 39.5457 41.3012 39.5457C42.1344 39.5457 42.837 39.6968 43.4092 39.9989C43.986 40.3011 44.4323 40.7176 44.7482 41.2486C45.0686 41.7796 45.2609 42.3839 45.325 43.0614H43.265C43.2422 42.6585 43.162 42.3175 43.0247 42.0383C42.8874 41.7545 42.6791 41.5416 42.3999 41.3997C42.1252 41.2532 41.759 41.18 41.3012 41.18C40.9579 41.18 40.6581 41.244 40.4017 41.3722C40.1454 41.5004 39.9302 41.6949 39.7563 41.9559C39.5823 42.2168 39.4519 42.5464 39.3649 42.9446C39.2825 43.3383 39.2413 43.8007 39.2413 44.3317V45.0389C39.2413 45.5562 39.2802 46.0117 39.358 46.4053C39.4359 46.7944 39.5549 47.124 39.7151 47.3941C39.8799 47.6596 40.0905 47.861 40.3468 47.9984C40.6077 48.1311 40.9213 48.1975 41.2875 48.1975C41.7178 48.1975 42.0726 48.1288 42.3518 47.9915C42.631 47.8542 42.8439 47.6505 42.9904 47.3804C43.1414 47.1103 43.2307 46.7738 43.2582 46.371Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7251_23361"
        x1="31.75"
        y1="0.75"
        x2="31.75"
        y2="63.25"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0F2830" />
        <stop offset="1" stopColor="#014751" />
      </linearGradient>
    </defs>
  </svg>
);

export const DOCXIcon = (
  <svg
    width="63"
    height="64"
    viewBox="0 0 63 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.25 7C6.25 3.54822 9.04822 0.75 12.5 0.75H37.5L56.25 19.5V57C56.25 60.4518 53.4518 63.25 50 63.25H12.5C9.04822 63.25 6.25 60.4518 6.25 57V7Z"
      fill="url(#paint0_linear_7251_23368)"
    />
    <path
      opacity="0.3"
      d="M37.5 0.75L56.25 19.5H43.75C40.2982 19.5 37.5 16.7018 37.5 13.25V0.75Z"
      fill="white"
    />
    <path
      d="M16.7274 49.6875H14.5508L14.5645 48.0807H16.7274C17.2676 48.0807 17.7231 47.9594 18.0939 47.7168C18.4647 47.4696 18.7439 47.1103 18.9316 46.6388C19.1238 46.1673 19.22 45.5974 19.22 44.929V44.4415C19.22 43.9288 19.165 43.4779 19.0552 43.0888C18.9499 42.6997 18.792 42.3724 18.5814 42.1069C18.3708 41.8414 18.1122 41.6423 17.8055 41.5096C17.4988 41.3722 17.1463 41.3036 16.748 41.3036H14.5096V39.6899H16.748C17.4164 39.6899 18.0275 39.8044 18.5814 40.0333C19.1399 40.2576 19.6228 40.5803 20.0302 41.0014C20.4376 41.4226 20.7512 41.9261 20.9709 42.5121C21.1952 43.0934 21.3074 43.7411 21.3074 44.4553V44.929C21.3074 45.6386 21.1952 46.2863 20.9709 46.8723C20.7512 47.4582 20.4376 47.9617 20.0302 48.3829C19.6274 48.7994 19.1444 49.1222 18.5814 49.351C18.0229 49.5753 17.4049 49.6875 16.7274 49.6875ZM15.7181 39.6899V49.6875H13.6581V39.6899H15.7181ZM31.0165 44.4553V44.929C31.0165 45.6889 30.9135 46.371 30.7076 46.9753C30.5016 47.5795 30.2109 48.0945 29.8355 48.5202C29.4601 48.9413 29.0115 49.2641 28.4897 49.4884C27.9724 49.7127 27.3979 49.8248 26.7662 49.8248C26.1391 49.8248 25.5646 49.7127 25.0427 49.4884C24.5255 49.2641 24.0768 48.9413 23.6969 48.5202C23.317 48.0945 23.0217 47.5795 22.8111 46.9753C22.6051 46.371 22.5021 45.6889 22.5021 44.929V44.4553C22.5021 43.6908 22.6051 43.0087 22.8111 42.4091C23.0171 41.8048 23.3078 41.2898 23.6832 40.8641C24.0631 40.4384 24.5117 40.1134 25.029 39.8891C25.5508 39.6648 26.1253 39.5526 26.7525 39.5526C27.3842 39.5526 27.9587 39.6648 28.476 39.8891C28.9978 40.1134 29.4464 40.4384 29.8218 40.8641C30.2017 41.2898 30.4947 41.8048 30.7007 42.4091C30.9113 43.0087 31.0165 43.6908 31.0165 44.4553ZM28.936 44.929V44.4415C28.936 43.9105 28.8879 43.4436 28.7918 43.0408C28.6957 42.6379 28.5538 42.2992 28.3661 42.0245C28.1784 41.7499 27.9495 41.5439 27.6794 41.4066C27.4094 41.2646 27.1004 41.1937 26.7525 41.1937C26.4046 41.1937 26.0956 41.2646 25.8255 41.4066C25.56 41.5439 25.3334 41.7499 25.1457 42.0245C24.9626 42.2992 24.823 42.6379 24.7269 43.0408C24.6307 43.4436 24.5827 43.9105 24.5827 44.4415V44.929C24.5827 45.4555 24.6307 45.9224 24.7269 46.3298C24.823 46.7326 24.9649 47.0737 25.1526 47.3529C25.3403 47.6276 25.5692 47.8358 25.8392 47.9778C26.1093 48.1197 26.4183 48.1906 26.7662 48.1906C27.1141 48.1906 27.4231 48.1197 27.6932 47.9778C27.9633 47.8358 28.1898 47.6276 28.373 47.3529C28.5561 47.0737 28.6957 46.7326 28.7918 46.3298C28.8879 45.9224 28.936 45.4555 28.936 44.929ZM38.295 46.371H40.3481C40.3069 47.0439 40.1215 47.6413 39.7919 48.1631C39.4669 48.685 39.0114 49.0924 38.4254 49.3854C37.8441 49.6783 37.1437 49.8248 36.3243 49.8248C35.6834 49.8248 35.1089 49.715 34.6008 49.4952C34.0927 49.2709 33.6578 48.9505 33.2962 48.5339C32.9391 48.1174 32.6668 47.6138 32.4791 47.0233C32.2914 46.4328 32.1976 45.7713 32.1976 45.0389V44.3454C32.1976 43.613 32.2937 42.9515 32.486 42.361C32.6828 41.7659 32.962 41.2601 33.3237 40.8435C33.6899 40.4269 34.127 40.1065 34.6352 39.8822C35.1433 39.6579 35.7109 39.5457 36.338 39.5457C37.1712 39.5457 37.8738 39.6968 38.446 39.9989C39.0228 40.3011 39.4691 40.7176 39.785 41.2486C40.1054 41.7796 40.2977 42.3839 40.3618 43.0614H38.3018C38.279 42.6585 38.1989 42.3175 38.0615 42.0383C37.9242 41.7545 37.7159 41.5416 37.4367 41.3997C37.162 41.2532 36.7958 41.18 36.338 41.18C35.9947 41.18 35.6949 41.244 35.4385 41.3722C35.1822 41.5004 34.967 41.6949 34.7931 41.9559C34.6191 42.2168 34.4887 42.5464 34.4017 42.9446C34.3193 43.3383 34.2781 43.8007 34.2781 44.3317V45.0389C34.2781 45.5562 34.317 46.0117 34.3948 46.4053C34.4727 46.7944 34.5917 47.124 34.7519 47.3941C34.9167 47.6596 35.1273 47.861 35.3836 47.9984C35.6445 48.1311 35.9581 48.1975 36.3243 48.1975C36.7546 48.1975 37.1094 48.1288 37.3886 47.9915C37.6678 47.8542 37.8807 47.6505 38.0272 47.3804C38.1783 47.1103 38.2675 46.7738 38.295 46.371ZM43.3968 39.6899L45.2782 43.1781L47.1596 39.6899H49.5148L46.6103 44.6475L49.5903 49.6875H47.2145L45.2782 46.1307L43.3418 49.6875H40.9523L43.9392 44.6475L41.0278 39.6899H43.3968Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7251_23368"
        x1="31.25"
        y1="0.75"
        x2="31.25"
        y2="63.25"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0F2830" />
        <stop offset="1" stopColor="#014751" />
      </linearGradient>
    </defs>
  </svg>
);

export const EPSIcon = (
  <svg
    width="63"
    height="63"
    viewBox="0 0 63 63"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.25 6.25C6.25 2.79822 9.04822 0 12.5 0H37.5L56.25 18.75V56.25C56.25 59.7018 53.4518 62.5 50 62.5H12.5C9.04822 62.5 6.25 59.7018 6.25 56.25V6.25Z"
      fill="url(#paint0_linear_7251_23365)"
    />
    <path
      opacity="0.3"
      d="M37.5 0L56.25 18.75H43.75C40.2982 18.75 37.5 15.9518 37.5 12.5V0Z"
      fill="white"
    />
    <path
      d="M26.0315 47.3307V48.9375H20.71V47.3307H26.0315ZM21.3829 38.9399V48.9375H19.323V38.9399H21.3829ZM25.338 43.0117V44.5773H20.71V43.0117H25.338ZM26.0246 38.9399V40.5536H20.71V38.9399H26.0246ZM31.1264 45.3738H28.5789V43.7671H31.1264C31.5201 43.7671 31.8405 43.703 32.0877 43.5748C32.3349 43.442 32.5157 43.2589 32.6302 43.0255C32.7446 42.792 32.8018 42.5288 32.8018 42.2358C32.8018 41.9383 32.7446 41.6613 32.6302 41.405C32.5157 41.1487 32.3349 40.9427 32.0877 40.787C31.8405 40.6314 31.5201 40.5536 31.1264 40.5536H29.2931V48.9375H27.2331V38.9399H31.1264C31.9092 38.9399 32.5798 39.0818 33.1383 39.3657C33.7013 39.6449 34.1316 40.0317 34.4292 40.5261C34.7267 41.0205 34.8755 41.5858 34.8755 42.2221C34.8755 42.8676 34.7267 43.426 34.4292 43.8975C34.1316 44.369 33.7013 44.7329 33.1383 44.9893C32.5798 45.2456 31.9092 45.3738 31.1264 45.3738ZM41.5016 46.3214C41.5016 46.1429 41.4742 45.9826 41.4192 45.8407C41.3689 45.6942 41.2727 45.5615 41.1308 45.4425C40.9889 45.3189 40.7898 45.1976 40.5334 45.0786C40.2771 44.9595 39.9452 44.8359 39.5378 44.7078C39.0846 44.5613 38.6543 44.3965 38.2469 44.2134C37.8441 44.0303 37.487 43.8174 37.1758 43.5748C36.869 43.3276 36.6264 43.0415 36.4479 42.7165C36.274 42.3915 36.187 42.0138 36.187 41.5835C36.187 41.167 36.2785 40.7893 36.4616 40.4506C36.6447 40.1072 36.9011 39.8143 37.2307 39.5717C37.5603 39.3245 37.9494 39.1345 38.398 39.0017C38.8512 38.869 39.3478 38.8026 39.888 38.8026C40.625 38.8026 41.2682 38.9354 41.8175 39.2009C42.3668 39.4664 42.7925 39.8303 43.0946 40.2926C43.4013 40.755 43.5547 41.2837 43.5547 41.8788H41.5085C41.5085 41.5858 41.4467 41.3295 41.3231 41.1097C41.2041 40.8854 41.021 40.7092 40.7738 40.581C40.5312 40.4529 40.2245 40.3888 39.8537 40.3888C39.4966 40.3888 39.1991 40.4437 38.961 40.5536C38.723 40.6588 38.5445 40.803 38.4254 40.9861C38.3064 41.1647 38.2469 41.3661 38.2469 41.5904C38.2469 41.7598 38.2881 41.9131 38.3705 42.0504C38.4575 42.1878 38.5857 42.3159 38.755 42.435C38.9244 42.554 39.1327 42.6661 39.3799 42.7714C39.6271 42.8767 39.9132 42.9797 40.2382 43.0804C40.7829 43.2452 41.2613 43.4306 41.6733 43.6366C42.0898 43.8426 42.4377 44.0738 42.717 44.3301C42.9962 44.5865 43.2068 44.8771 43.3487 45.2021C43.4906 45.5272 43.5616 45.8957 43.5616 46.3076C43.5616 46.7425 43.4769 47.1316 43.3075 47.4749C43.1381 47.8183 42.8932 48.1089 42.5728 48.347C42.2523 48.585 41.8701 48.7658 41.4261 48.8894C40.9821 49.013 40.4854 49.0748 39.9361 49.0748C39.4417 49.0748 38.9542 49.0107 38.4735 48.8826C37.9929 48.7498 37.5557 48.5507 37.162 48.2852C36.7729 48.0197 36.4616 47.6809 36.2282 47.269C35.9947 46.857 35.878 46.3694 35.878 45.8064H37.9448C37.9448 46.1177 37.9929 46.3809 38.089 46.596C38.1851 46.8112 38.3202 46.9851 38.4941 47.1179C38.6726 47.2506 38.8832 47.3468 39.1258 47.4063C39.373 47.4658 39.6431 47.4955 39.9361 47.4955C40.2931 47.4955 40.5861 47.4452 40.815 47.3445C41.0484 47.2438 41.2201 47.1042 41.33 46.9256C41.4444 46.7471 41.5016 46.5457 41.5016 46.3214Z"
      fill="#0B0B0B"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7251_23365"
        x1="31.25"
        y1="0"
        x2="31.25"
        y2="62.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E7A370" />
        <stop offset="1" stopColor="#ECB88E" />
      </linearGradient>
    </defs>
  </svg>
);

export const GIFIcon = (
  <svg
    width="63"
    height="63"
    viewBox="0 0 63 63"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.25 6.25C6.25 2.79822 9.04822 0 12.5 0H37.5L56.25 18.75V56.25C56.25 59.7018 53.4518 62.5 50 62.5H12.5C9.04822 62.5 6.25 59.7018 6.25 56.25V6.25Z"
      fill="url(#paint0_linear_7251_23369)"
    />
    <path
      opacity="0.3"
      d="M37.5 0L56.25 18.75H43.75C40.2982 18.75 37.5 15.9518 37.5 12.5V0Z"
      fill="white"
    />
    <path
      d="M29.3549 43.7121V47.6741C29.1992 47.8618 28.9589 48.0655 28.6339 48.2852C28.3089 48.5003 27.89 48.6857 27.3773 48.8414C26.8646 48.997 26.2444 49.0748 25.5165 49.0748C24.8711 49.0748 24.2828 48.9695 23.7518 48.759C23.2208 48.5438 22.7631 48.2303 22.3785 47.8183C21.9986 47.4063 21.7056 46.9027 21.4996 46.3076C21.2936 45.708 21.1906 45.0236 21.1906 44.2546V43.6297C21.1906 42.8607 21.2891 42.1763 21.4859 41.5767C21.6873 40.977 21.9734 40.4712 22.3442 40.0592C22.715 39.6472 23.1567 39.3336 23.6694 39.1185C24.1821 38.9033 24.752 38.7957 25.3792 38.7957C26.2489 38.7957 26.963 38.9377 27.5215 39.2215C28.08 39.5007 28.5057 39.8898 28.7987 40.3888C29.0962 40.8831 29.2793 41.4508 29.348 42.0916H27.3499C27.2995 41.7529 27.2034 41.4576 27.0615 41.2059C26.9196 40.9541 26.7159 40.7573 26.4503 40.6154C26.1894 40.4734 25.8507 40.4025 25.4341 40.4025C25.0908 40.4025 24.7841 40.4734 24.514 40.6154C24.2485 40.7527 24.0242 40.9564 23.8411 41.2265C23.658 41.4966 23.5184 41.8307 23.4222 42.229C23.3261 42.6272 23.278 43.0896 23.278 43.616V44.2546C23.278 44.7764 23.3284 45.2388 23.4291 45.6416C23.5298 46.0399 23.6786 46.3763 23.8754 46.651C24.0768 46.9211 24.324 47.1248 24.617 47.2621C24.91 47.3994 25.251 47.4681 25.6401 47.4681C25.9651 47.4681 26.2352 47.4406 26.4503 47.3857C26.6701 47.3307 26.8463 47.2644 26.9791 47.1866C27.1164 47.1042 27.2217 47.0263 27.2949 46.9531V45.1815H25.4135V43.7121H29.3549ZM33.2069 38.9399V48.9375H31.1539V38.9399H33.2069ZM37.1964 38.9399V48.9375H35.1364V38.9399H37.1964ZM41.1789 43.2109V44.8176H36.6333V43.2109H41.1789ZM41.6595 38.9399V40.5536H36.6333V38.9399H41.6595Z"
      fill="#0B0B0B"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7251_23369"
        x1="31.25"
        y1="0"
        x2="31.25"
        y2="62.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E7A370" />
        <stop offset="1" stopColor="#ECB88E" />
      </linearGradient>
    </defs>
  </svg>
);

export const IMGIcon = (
  <svg
    width="63"
    height="63"
    viewBox="0 0 63 63"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.25 6.25C6.25 2.79822 9.04822 0 12.5 0H37.5L56.25 18.75V56.25C56.25 59.7018 53.4518 62.5 50 62.5H12.5C9.04822 62.5 6.25 59.7018 6.25 56.25V6.25Z"
      fill="url(#paint0_linear_7251_23377)"
    />
    <path
      opacity="0.3"
      d="M37.5 0L56.25 18.75H43.75C40.2982 18.75 37.5 15.9518 37.5 12.5V0Z"
      fill="white"
    />
    <path
      d="M21.3211 38.9399V48.9375H19.268V38.9399H21.3211ZM24.1913 38.9399H25.9354L28.5034 46.2802L31.0715 38.9399H32.8156L29.2038 48.9375H27.803L24.1913 38.9399ZM23.2506 38.9399H24.9878L25.3036 46.0948V48.9375H23.2506V38.9399ZM32.019 38.9399H33.7631V48.9375H31.7032V46.0948L32.019 38.9399ZM43.4929 43.7121V47.6741C43.3372 47.8618 43.0969 48.0655 42.7719 48.2852C42.4469 48.5003 42.028 48.6857 41.5154 48.8414C41.0027 48.997 40.3824 49.0748 39.6545 49.0748C39.0091 49.0748 38.4209 48.9695 37.8899 48.759C37.3589 48.5438 36.9011 48.2303 36.5166 47.8183C36.1366 47.4063 35.8437 46.9027 35.6377 46.3076C35.4317 45.708 35.3287 45.0236 35.3287 44.2546V43.6297C35.3287 42.8607 35.4271 42.1763 35.6239 41.5767C35.8253 40.977 36.1115 40.4712 36.4822 40.0592C36.853 39.6472 37.2948 39.3336 37.8075 39.1185C38.3202 38.9033 38.8901 38.7957 39.5172 38.7957C40.387 38.7957 41.1011 38.9377 41.6595 39.2215C42.218 39.5007 42.6437 39.8898 42.9367 40.3888C43.2343 40.8831 43.4174 41.4508 43.486 42.0916H41.4879C41.4375 41.7529 41.3414 41.4576 41.1995 41.2059C41.0576 40.9541 40.8539 40.7573 40.5884 40.6154C40.3275 40.4734 39.9887 40.4025 39.5721 40.4025C39.2288 40.4025 38.9221 40.4734 38.652 40.6154C38.3865 40.7527 38.1622 40.9564 37.9791 41.2265C37.796 41.4966 37.6564 41.8307 37.5603 42.229C37.4641 42.6272 37.4161 43.0896 37.4161 43.616V44.2546C37.4161 44.7764 37.4664 45.2388 37.5671 45.6416C37.6678 46.0399 37.8166 46.3763 38.0135 46.651C38.2149 46.9211 38.4621 47.1248 38.755 47.2621C39.048 47.3994 39.389 47.4681 39.7781 47.4681C40.1031 47.4681 40.3732 47.4406 40.5884 47.3857C40.8081 47.3307 40.9843 47.2644 41.1171 47.1866C41.2544 47.1042 41.3597 47.0263 41.433 46.9531V45.1815H39.5515V43.7121H43.4929Z"
      fill="#0B0B0B"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7251_23377"
        x1="31.25"
        y1="0"
        x2="31.25"
        y2="62.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E7A370" />
        <stop offset="1" stopColor="#ECB88E" />
      </linearGradient>
    </defs>
  </svg>
);

export const JPEGIcon = (
  <svg
    width="63"
    height="63"
    viewBox="0 0 63 63"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.25 6.25C6.25 2.79822 9.04822 0 12.5 0H37.5L56.25 18.75V56.25C56.25 59.7018 53.4518 62.5 50 62.5H12.5C9.04822 62.5 6.25 59.7018 6.25 56.25V6.25Z"
      fill="url(#paint0_linear_7251_23371)"
    />
    <path
      opacity="0.3"
      d="M37.5 0L56.25 18.75H43.75C40.2982 18.75 37.5 15.9518 37.5 12.5V0Z"
      fill="white"
    />
    <path
      d="M18.9796 45.8682V38.9399H21.0327V45.8682C21.0327 46.5365 20.8862 47.111 20.5933 47.5917C20.3003 48.0677 19.8997 48.434 19.3916 48.6903C18.8881 48.9467 18.3205 49.0748 17.6888 49.0748C17.0341 49.0748 16.4551 48.965 15.9515 48.7452C15.448 48.5255 15.052 48.1891 14.7636 47.7359C14.4753 47.2781 14.3311 46.699 14.3311 45.9987H16.3979C16.3979 46.3649 16.4482 46.6555 16.5489 46.8707C16.6542 47.0858 16.803 47.2392 16.9952 47.3307C17.1875 47.4223 17.4187 47.4681 17.6888 47.4681C17.9497 47.4681 18.1763 47.4063 18.3685 47.2827C18.5608 47.1591 18.7096 46.9783 18.8148 46.7402C18.9247 46.5022 18.9796 46.2115 18.9796 45.8682ZM26.6838 45.3738H24.1364V43.7671H26.6838C27.0775 43.7671 27.3979 43.703 27.6451 43.5748C27.8923 43.442 28.0731 43.2589 28.1876 43.0255C28.302 42.792 28.3592 42.5288 28.3592 42.2358C28.3592 41.9383 28.302 41.6613 28.1876 41.405C28.0731 41.1487 27.8923 40.9427 27.6451 40.787C27.3979 40.6314 27.0775 40.5536 26.6838 40.5536H24.8505V48.9375H22.7905V38.9399H26.6838C27.4666 38.9399 28.1372 39.0818 28.6957 39.3657C29.2587 39.6449 29.689 40.0317 29.9866 40.5261C30.2841 41.0205 30.4329 41.5858 30.4329 42.2221C30.4329 42.8676 30.2841 43.426 29.9866 43.8975C29.689 44.369 29.2587 44.7329 28.6957 44.9893C28.1372 45.2456 27.4666 45.3738 26.6838 45.3738ZM38.5628 47.3307V48.9375H33.2413V47.3307H38.5628ZM33.9142 38.9399V48.9375H31.8542V38.9399H33.9142ZM37.8693 43.0117V44.5773H33.2413V43.0117H37.8693ZM38.5559 38.9399V40.5536H33.2413V38.9399H38.5559ZM47.6883 43.7121V47.6741C47.5327 47.8618 47.2923 48.0655 46.9673 48.2852C46.6423 48.5003 46.2234 48.6857 45.7108 48.8414C45.1981 48.997 44.5778 49.0748 43.8499 49.0748C43.2045 49.0748 42.6163 48.9695 42.0853 48.759C41.5543 48.5438 41.0965 48.2303 40.712 47.8183C40.332 47.4063 40.0391 46.9027 39.8331 46.3076C39.6271 45.708 39.5241 45.0236 39.5241 44.2546V43.6297C39.5241 42.8607 39.6225 42.1763 39.8193 41.5767C40.0208 40.977 40.3069 40.4712 40.6776 40.0592C41.0484 39.6472 41.4902 39.3336 42.0029 39.1185C42.5156 38.9033 43.0855 38.7957 43.7126 38.7957C44.5824 38.7957 45.2965 38.9377 45.8549 39.2215C46.4134 39.5007 46.8391 39.8898 47.1321 40.3888C47.4297 40.8831 47.6128 41.4508 47.6814 42.0916H45.6833C45.6329 41.7529 45.5368 41.4576 45.3949 41.2059C45.253 40.9541 45.0493 40.7573 44.7838 40.6154C44.5229 40.4734 44.1841 40.4025 43.7675 40.4025C43.4242 40.4025 43.1175 40.4734 42.8474 40.6154C42.5819 40.7527 42.3576 40.9564 42.1745 41.2265C41.9914 41.4966 41.8518 41.8307 41.7557 42.229C41.6595 42.6272 41.6115 43.0896 41.6115 43.616V44.2546C41.6115 44.7764 41.6618 45.2388 41.7625 45.6416C41.8633 46.0399 42.012 46.3763 42.2089 46.651C42.4103 46.9211 42.6575 47.1248 42.9504 47.2621C43.2434 47.3994 43.5844 47.4681 43.9735 47.4681C44.2986 47.4681 44.5686 47.4406 44.7838 47.3857C45.0035 47.3307 45.1797 47.2644 45.3125 47.1866C45.4498 47.1042 45.5551 47.0263 45.6284 46.9531V45.1815H43.7469V43.7121H47.6883Z"
      fill="#0B0B0B"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7251_23371"
        x1="31.25"
        y1="0"
        x2="31.25"
        y2="62.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E7A370" />
        <stop offset="1" stopColor="#ECB88E" />
      </linearGradient>
    </defs>
  </svg>
);

export const JPGIcon = (
  <svg
    width="63"
    height="63"
    viewBox="0 0 63 63"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.75 6.25C6.75 2.79822 9.54822 0 13 0H38L56.75 18.75V56.25C56.75 59.7018 53.9518 62.5 50.5 62.5H13C9.54822 62.5 6.75 59.7018 6.75 56.25V6.25Z"
      fill="url(#paint0_linear_7251_23373)"
    />
    <path
      opacity="0.3"
      d="M38 0L56.75 18.75H44.25C40.7982 18.75 38 15.9518 38 12.5V0Z"
      fill="white"
    />
    <path
      d="M23.4347 45.8682V38.9399H25.4878V45.8682C25.4878 46.5365 25.3413 47.111 25.0483 47.5917C24.7554 48.0677 24.3548 48.434 23.8467 48.6903C23.3432 48.9467 22.7755 49.0748 22.1438 49.0748C21.4892 49.0748 20.9102 48.965 20.4066 48.7452C19.9031 48.5255 19.5071 48.1891 19.2187 47.7359C18.9303 47.2781 18.7861 46.699 18.7861 45.9987H20.8529C20.8529 46.3649 20.9033 46.6555 21.004 46.8707C21.1093 47.0858 21.2581 47.2392 21.4503 47.3307C21.6426 47.4223 21.8737 47.4681 22.1438 47.4681C22.4048 47.4681 22.6313 47.4063 22.8236 47.2827C23.0159 47.1591 23.1646 46.9783 23.2699 46.7402C23.3798 46.5022 23.4347 46.2115 23.4347 45.8682ZM31.1389 45.3738H28.5914V43.7671H31.1389C31.5326 43.7671 31.853 43.703 32.1002 43.5748C32.3474 43.442 32.5282 43.2589 32.6426 43.0255C32.7571 42.792 32.8143 42.5288 32.8143 42.2358C32.8143 41.9383 32.7571 41.6613 32.6426 41.405C32.5282 41.1487 32.3474 40.9427 32.1002 40.787C31.853 40.6314 31.5326 40.5536 31.1389 40.5536H29.3055V48.9375H27.2456V38.9399H31.1389C31.9217 38.9399 32.5923 39.0818 33.1508 39.3657C33.7138 39.6449 34.1441 40.0317 34.4417 40.5261C34.7392 41.0205 34.888 41.5858 34.888 42.2221C34.888 42.8676 34.7392 43.426 34.4417 43.8975C34.1441 44.369 33.7138 44.7329 33.1508 44.9893C32.5923 45.2456 31.9217 45.3738 31.1389 45.3738ZM44.2332 43.7121V47.6741C44.0776 47.8618 43.8372 48.0655 43.5122 48.2852C43.1872 48.5003 42.7684 48.6857 42.2557 48.8414C41.743 48.997 41.1227 49.0748 40.3949 49.0748C39.7494 49.0748 39.1612 48.9695 38.6302 48.759C38.0992 48.5438 37.6414 48.2303 37.2569 47.8183C36.877 47.4063 36.584 46.9027 36.378 46.3076C36.172 45.708 36.069 45.0236 36.069 44.2546V43.6297C36.069 42.8607 36.1674 42.1763 36.3643 41.5767C36.5657 40.977 36.8518 40.4712 37.2226 40.0592C37.5934 39.6472 38.0351 39.3336 38.5478 39.1185C39.0605 38.9033 39.6304 38.7957 40.2575 38.7957C41.1273 38.7957 41.8414 38.9377 42.3999 39.2215C42.9583 39.5007 43.3841 39.8898 43.677 40.3888C43.9746 40.8831 44.1577 41.4508 44.2263 42.0916H42.2282C42.1779 41.7529 42.0817 41.4576 41.9398 41.2059C41.7979 40.9541 41.5942 40.7573 41.3287 40.6154C41.0678 40.4734 40.729 40.4025 40.3125 40.4025C39.9691 40.4025 39.6624 40.4734 39.3924 40.6154C39.1269 40.7527 38.9026 40.9564 38.7195 41.2265C38.5363 41.4966 38.3967 41.8307 38.3006 42.229C38.2045 42.6272 38.1564 43.0896 38.1564 43.616V44.2546C38.1564 44.7764 38.2068 45.2388 38.3075 45.6416C38.4082 46.0399 38.5569 46.3763 38.7538 46.651C38.9552 46.9211 39.2024 47.1248 39.4954 47.2621C39.7883 47.3994 40.1294 47.4681 40.5185 47.4681C40.8435 47.4681 41.1136 47.4406 41.3287 47.3857C41.5484 47.3307 41.7247 47.2644 41.8574 47.1866C41.9948 47.1042 42.1 47.0263 42.1733 46.9531V45.1815H40.2919V43.7121H44.2332Z"
      fill="#0B0B0B"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7251_23373"
        x1="31.75"
        y1="0"
        x2="31.75"
        y2="62.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E7A370" />
        <stop offset="1" stopColor="#ECB88E" />
      </linearGradient>
    </defs>
  </svg>
);

export const MP3Icon = (
  <svg
    width="63"
    height="64"
    viewBox="0 0 63 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.75 7C6.75 3.54822 9.54822 0.75 13 0.75H38L56.75 19.5V57C56.75 60.4518 53.9518 63.25 50.5 63.25H13C9.54822 63.25 6.75 60.4518 6.75 57V7Z"
      fill="url(#paint0_linear_7251_23375)"
    />
    <path
      opacity="0.3"
      d="M38 0.75L56.75 19.5H44.25C40.7982 19.5 38 16.7018 38 13.25V0.75Z"
      fill="white"
    />
    <path
      d="M18.8548 39.6899H20.5989L23.1669 47.0302L25.735 39.6899H27.4791L23.8673 49.6875H22.4666L18.8548 39.6899ZM17.9141 39.6899H19.6513L19.9672 46.8448V49.6875H17.9141V39.6899ZM26.6826 39.6899H28.4266V49.6875H26.3667V46.8448L26.6826 39.6899ZM34.1258 46.1238H31.5783V44.5171H34.1258C34.5195 44.5171 34.8399 44.453 35.0871 44.3248C35.3343 44.192 35.5151 44.0089 35.6295 43.7755C35.744 43.542 35.8012 43.2788 35.8012 42.9858C35.8012 42.6883 35.744 42.4113 35.6295 42.155C35.5151 41.8987 35.3343 41.6927 35.0871 41.537C34.8399 41.3814 34.5195 41.3036 34.1258 41.3036H32.2924V49.6875H30.2325V39.6899H34.1258C34.9086 39.6899 35.5792 39.8318 36.1377 40.1157C36.7007 40.3949 37.131 40.7817 37.4286 41.2761C37.7261 41.7705 37.8749 42.3358 37.8749 42.9721C37.8749 43.6176 37.7261 44.176 37.4286 44.6475C37.131 45.119 36.7007 45.4829 36.1377 45.7393C35.5792 45.9956 34.9086 46.1238 34.1258 46.1238ZM41.1158 43.8304H42.1733C42.512 43.8304 42.7913 43.7732 43.011 43.6588C43.2307 43.5397 43.3932 43.3749 43.4985 43.1644C43.6084 42.9492 43.6633 42.6997 43.6633 42.4159C43.6633 42.1596 43.6129 41.933 43.5122 41.7361C43.4161 41.5347 43.2673 41.3791 43.0659 41.2692C42.8645 41.1548 42.6104 41.0976 42.3037 41.0976C42.0611 41.0976 41.8368 41.1456 41.6308 41.2418C41.4248 41.3379 41.26 41.4729 41.1364 41.6469C41.0128 41.8208 40.951 42.0314 40.951 42.2786H38.9666C38.9666 41.7293 39.1131 41.2509 39.4061 40.8435C39.7036 40.4361 40.1019 40.118 40.6009 39.8891C41.0998 39.6602 41.6491 39.5457 42.2488 39.5457C42.9263 39.5457 43.5191 39.6556 44.0272 39.8753C44.5353 40.0905 44.9313 40.4086 45.2151 40.8298C45.4989 41.2509 45.6408 41.7728 45.6408 42.3953C45.6408 42.7112 45.5676 43.0179 45.4211 43.3154C45.2746 43.6084 45.0641 43.8739 44.7894 44.1119C44.5193 44.3454 44.1897 44.5331 43.8006 44.675C43.4115 44.8123 42.9744 44.881 42.4891 44.881H41.1158V43.8304ZM41.1158 45.3342V44.3111H42.4891C43.0339 44.3111 43.5122 44.3729 43.9242 44.4965C44.3362 44.6201 44.6818 44.7986 44.9611 45.032C45.2403 45.2609 45.4509 45.5333 45.5928 45.8492C45.7347 46.1604 45.8056 46.506 45.8056 46.886C45.8056 47.3529 45.7164 47.7695 45.5378 48.1357C45.3593 48.4973 45.1075 48.804 44.7825 49.0558C44.4621 49.3076 44.0867 49.4998 43.6564 49.6326C43.2261 49.7607 42.7569 49.8248 42.2488 49.8248C41.8277 49.8248 41.4134 49.7676 41.006 49.6532C40.6031 49.5341 40.2369 49.3579 39.9073 49.1245C39.5823 48.8864 39.3214 48.5889 39.1246 48.2318C38.9323 47.8702 38.8362 47.4422 38.8362 46.9478H40.8206C40.8206 47.2041 40.8847 47.433 41.0128 47.6344C41.141 47.8358 41.3173 47.9938 41.5416 48.1082C41.7704 48.2227 42.0245 48.2799 42.3037 48.2799C42.6196 48.2799 42.8897 48.2227 43.114 48.1082C43.3429 47.9892 43.5168 47.8244 43.6358 47.6138C43.7594 47.3987 43.8212 47.1492 43.8212 46.8654C43.8212 46.4992 43.7549 46.2062 43.6221 45.9865C43.4893 45.7622 43.2994 45.5974 43.0522 45.4921C42.805 45.3868 42.512 45.3342 42.1733 45.3342H41.1158Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7251_23375"
        x1="31.75"
        y1="0.75"
        x2="31.75"
        y2="63.25"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0F2830" />
        <stop offset="1" stopColor="#014751" />
      </linearGradient>
    </defs>
  </svg>
);

export const MP4Icon = (
  <svg
    width="63"
    height="64"
    viewBox="0 0 63 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.25 7C6.25 3.54822 9.04822 0.75 12.5 0.75H37.5L56.25 19.5V57C56.25 60.4518 53.4518 63.25 50 63.25H12.5C9.04822 63.25 6.25 60.4518 6.25 57V7Z"
      fill="url(#paint0_linear_7251_23357)"
    />
    <path
      opacity="0.3"
      d="M37.5 0.75L56.25 19.5H43.75C40.2982 19.5 37.5 16.7018 37.5 13.25V0.75Z"
      fill="white"
    />
    <path
      d="M18.3548 39.6899H20.0989L22.6669 47.0302L25.235 39.6899H26.9791L23.3673 49.6875H21.9666L18.3548 39.6899ZM17.4141 39.6899H19.1513L19.4672 46.8448V49.6875H17.4141V39.6899ZM26.1826 39.6899H27.9266V49.6875H25.8667V46.8448L26.1826 39.6899ZM33.6258 46.1238H31.0783V44.5171H33.6258C34.0195 44.5171 34.3399 44.453 34.5871 44.3248C34.8343 44.192 35.0151 44.0089 35.1295 43.7755C35.244 43.542 35.3012 43.2788 35.3012 42.9858C35.3012 42.6883 35.244 42.4113 35.1295 42.155C35.0151 41.8987 34.8343 41.6927 34.5871 41.537C34.3399 41.3814 34.0195 41.3036 33.6258 41.3036H31.7924V49.6875H29.7325V39.6899H33.6258C34.4086 39.6899 35.0792 39.8318 35.6377 40.1157C36.2007 40.3949 36.631 40.7817 36.9286 41.2761C37.2261 41.7705 37.3749 42.3358 37.3749 42.9721C37.3749 43.6176 37.2261 44.176 36.9286 44.6475C36.631 45.119 36.2007 45.4829 35.6377 45.7393C35.0792 45.9956 34.4086 46.1238 33.6258 46.1238ZM45.594 45.9521V47.504H38.3911L38.295 46.3023L42.4629 39.6899H44.0353L42.3325 42.5395L40.2588 45.9521H45.594ZM44.4611 39.6899V49.6875H42.4835V39.6899H44.4611Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7251_23357"
        x1="31.25"
        y1="0.75"
        x2="31.25"
        y2="63.25"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0F2830" />
        <stop offset="1" stopColor="#014751" />
      </linearGradient>
    </defs>
  </svg>
);

export const PDFIcon = (
  <svg
    width="63"
    height="64"
    viewBox="0 0 63 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.25 7C6.25 3.54822 9.04822 0.75 12.5 0.75H37.5L56.25 19.5V57C56.25 60.4518 53.4518 63.25 50 63.25H12.5C9.04822 63.25 6.25 60.4518 6.25 57V7Z"
      fill="#D92D20"
    />
    <path
      opacity="0.3"
      d="M37.5 0.75L56.25 19.5H43.75C40.2982 19.5 37.5 16.7018 37.5 13.25V0.75Z"
      fill="white"
    />
    <path
      d="M23.0721 46.1238H20.5246V44.5171H23.0721C23.4657 44.5171 23.7862 44.453 24.0334 44.3248C24.2805 44.192 24.4614 44.0089 24.5758 43.7755C24.6902 43.542 24.7475 43.2788 24.7475 42.9858C24.7475 42.6883 24.6902 42.4113 24.5758 42.155C24.4614 41.8987 24.2805 41.6927 24.0334 41.537C23.7862 41.3814 23.4657 41.3036 23.0721 41.3036H21.2387V49.6875H19.1788V39.6899H23.0721C23.8548 39.6899 24.5255 39.8318 25.0839 40.1157C25.647 40.3949 26.0773 40.7817 26.3748 41.2761C26.6724 41.7705 26.8211 42.3358 26.8211 42.9721C26.8211 43.6176 26.6724 44.176 26.3748 44.6475C26.0773 45.119 25.647 45.4829 25.0839 45.7393C24.5255 45.9956 23.8548 46.1238 23.0721 46.1238ZM31.3118 49.6875H29.1351L29.1489 48.0807H31.3118C31.852 48.0807 32.3074 47.9594 32.6782 47.7168C33.049 47.4696 33.3282 47.1103 33.5159 46.6388C33.7082 46.1673 33.8043 45.5974 33.8043 44.929V44.4415C33.8043 43.9288 33.7494 43.4779 33.6395 43.0888C33.5342 42.6997 33.3763 42.3724 33.1657 42.1069C32.9552 41.8414 32.6965 41.6423 32.3898 41.5096C32.0831 41.3722 31.7307 41.3036 31.3324 41.3036H29.0939V39.6899H31.3324C32.0007 39.6899 32.6118 39.8044 33.1657 40.0333C33.7242 40.2576 34.2072 40.5803 34.6146 41.0014C35.022 41.4226 35.3355 41.9261 35.5553 42.5121C35.7796 43.0934 35.8917 43.7411 35.8917 44.4553V44.929C35.8917 45.6386 35.7796 46.2863 35.5553 46.8723C35.3355 47.4582 35.022 47.9617 34.6146 48.3829C34.2117 48.7994 33.7288 49.1222 33.1657 49.351C32.6073 49.5753 31.9893 49.6875 31.3118 49.6875ZM30.3024 39.6899V49.6875H28.2425V39.6899H30.3024ZM39.4485 39.6899V49.6875H37.3886V39.6899H39.4485ZM43.4311 43.9609V45.5676H38.8855V43.9609H43.4311ZM43.9117 39.6899V41.3036H38.8855V39.6899H43.9117Z"
      fill="white"
    />
  </svg>
);

export const PNGIcon = (
  <svg
    width="63"
    height="63"
    viewBox="0 0 63 63"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.75 6.25C6.75 2.79822 9.54822 0 13 0H38L56.75 18.75V56.25C56.75 59.7018 53.9518 62.5 50.5 62.5H13C9.54822 62.5 6.75 59.7018 6.75 56.25V6.25Z"
      fill="url(#paint0_linear_7251_23374)"
    />
    <path
      opacity="0.3"
      d="M38 0L56.75 18.75H44.25C40.7982 18.75 38 15.9518 38 12.5V0Z"
      fill="white"
    />
    <path
      d="M22.2468 45.3738H19.6994V43.7671H22.2468C22.6405 43.7671 22.9609 43.703 23.2081 43.5748C23.4553 43.442 23.6361 43.2589 23.7506 43.0255C23.865 42.792 23.9222 42.5288 23.9222 42.2358C23.9222 41.9383 23.865 41.6613 23.7506 41.405C23.6361 41.1487 23.4553 40.9427 23.2081 40.787C22.9609 40.6314 22.6405 40.5536 22.2468 40.5536H20.4135V48.9375H18.3535V38.9399H22.2468C23.0296 38.9399 23.7002 39.0818 24.2587 39.3657C24.8217 39.6449 25.252 40.0317 25.5496 40.5261C25.8471 41.0205 25.9959 41.5858 25.9959 42.2221C25.9959 42.8676 25.8471 43.426 25.5496 43.8975C25.252 44.369 24.8217 44.7329 24.2587 44.9893C23.7002 45.2456 23.0296 45.3738 22.2468 45.3738ZM35.554 38.9399V48.9375H33.4941L29.4772 42.2358V48.9375H27.4173V38.9399H29.4772L33.5009 45.6485V38.9399H35.554ZM45.2701 43.7121V47.6741C45.1144 47.8618 44.8741 48.0655 44.5491 48.2852C44.2241 48.5003 43.8052 48.6857 43.2925 48.8414C42.7798 48.997 42.1595 49.0748 41.4317 49.0748C40.7863 49.0748 40.198 48.9695 39.667 48.759C39.136 48.5438 38.6783 48.2303 38.2937 47.8183C37.9138 47.4063 37.6208 46.9027 37.4148 46.3076C37.2088 45.708 37.1058 45.0236 37.1058 44.2546V43.6297C37.1058 42.8607 37.2043 42.1763 37.4011 41.5767C37.6025 40.977 37.8886 40.4712 38.2594 40.0592C38.6302 39.6472 39.0719 39.3336 39.5846 39.1185C40.0973 38.9033 40.6672 38.7957 41.2944 38.7957C42.1641 38.7957 42.8782 38.9377 43.4367 39.2215C43.9952 39.5007 44.4209 39.8898 44.7139 40.3888C45.0114 40.8831 45.1945 41.4508 45.2632 42.0916H43.265C43.2147 41.7529 43.1186 41.4576 42.9767 41.2059C42.8347 40.9541 42.631 40.7573 42.3655 40.6154C42.1046 40.4734 41.7659 40.4025 41.3493 40.4025C41.006 40.4025 40.6993 40.4734 40.4292 40.6154C40.1637 40.7527 39.9394 40.9564 39.7563 41.2265C39.5732 41.4966 39.4336 41.8307 39.3374 42.229C39.2413 42.6272 39.1932 43.0896 39.1932 43.616V44.2546C39.1932 44.7764 39.2436 45.2388 39.3443 45.6416C39.445 46.0399 39.5938 46.3763 39.7906 46.651C39.992 46.9211 40.2392 47.1248 40.5322 47.2621C40.8252 47.3994 41.1662 47.4681 41.5553 47.4681C41.8803 47.4681 42.1504 47.4406 42.3655 47.3857C42.5853 47.3307 42.7615 47.2644 42.8943 47.1866C43.0316 47.1042 43.1369 47.0263 43.2101 46.9531V45.1815H41.3287V43.7121H45.2701Z"
      fill="#0B0B0B"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7251_23374"
        x1="31.75"
        y1="0"
        x2="31.75"
        y2="62.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E7A370" />
        <stop offset="1" stopColor="#ECB88E" />
      </linearGradient>
    </defs>
  </svg>
);

export const PPTIcon = (
  <svg
    width="64"
    height="63"
    viewBox="0 0 64 63"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 6.25C7 2.79822 9.79822 0 13.25 0H38.25L57 18.75V56.25C57 59.7018 54.2018 62.5 50.75 62.5H13.25C9.79822 62.5 7 59.7018 7 56.25V6.25Z"
      fill="url(#paint0_linear_7251_23359)"
    />
    <path
      opacity="0.3"
      d="M38.25 0L57 18.75H44.5C41.0482 18.75 38.25 15.9518 38.25 12.5V0Z"
      fill="white"
    />
    <path
      d="M23.362 45.3738H20.8145V43.7671H23.362C23.7557 43.7671 24.0761 43.703 24.3233 43.5748C24.5705 43.442 24.7513 43.2589 24.8658 43.0255C24.9802 42.792 25.0374 42.5288 25.0374 42.2358C25.0374 41.9383 24.9802 41.6613 24.8658 41.405C24.7513 41.1487 24.5705 40.9427 24.3233 40.787C24.0761 40.6314 23.7557 40.5536 23.362 40.5536H21.5287V48.9375H19.4687V38.9399H23.362C24.1448 38.9399 24.8154 39.0818 25.3739 39.3657C25.9369 39.6449 26.3672 40.0317 26.6648 40.5261C26.9623 41.0205 27.1111 41.5858 27.1111 42.2221C27.1111 42.8676 26.9623 43.426 26.6648 43.8975C26.3672 44.369 25.9369 44.7329 25.3739 44.9893C24.8154 45.2456 24.1448 45.3738 23.362 45.3738ZM32.4257 45.3738H29.8783V43.7671H32.4257C32.8194 43.7671 33.1398 43.703 33.387 43.5748C33.6342 43.442 33.815 43.2589 33.9295 43.0255C34.0439 42.792 34.1011 42.5288 34.1011 42.2358C34.1011 41.9383 34.0439 41.6613 33.9295 41.405C33.815 41.1487 33.6342 40.9427 33.387 40.787C33.1398 40.6314 32.8194 40.5536 32.4257 40.5536H30.5924V48.9375H28.5324V38.9399H32.4257C33.2085 38.9399 33.8791 39.0818 34.4376 39.3657C35.0006 39.6449 35.4309 40.0317 35.7285 40.5261C36.026 41.0205 36.1748 41.5858 36.1748 42.2221C36.1748 42.8676 36.026 43.426 35.7285 43.8975C35.4309 44.369 35.0006 44.7329 34.4376 44.9893C33.8791 45.2456 33.2085 45.3738 32.4257 45.3738ZM42.0662 38.9399V48.9375H40.0132V38.9399H42.0662ZM45.1424 38.9399V40.5536H36.985V38.9399H45.1424Z"
      fill="#0B0B0B"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7251_23359"
        x1="32"
        y1="0"
        x2="32"
        y2="62.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E7A370" />
        <stop offset="1" stopColor="#ECB88E" />
      </linearGradient>
    </defs>
  </svg>
);

export const PPTXIcon = (
  <svg
    width="63"
    height="63"
    viewBox="0 0 63 63"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.5 6.25C6.5 2.79822 9.29822 0 12.75 0H37.75L56.5 18.75V56.25C56.5 59.7018 53.7018 62.5 50.25 62.5H12.75C9.29822 62.5 6.5 59.7018 6.5 56.25V6.25Z"
      fill="url(#paint0_linear_7251_23358)"
    />
    <path
      opacity="0.3"
      d="M37.75 0L56.5 18.75H44C40.5482 18.75 37.75 15.9518 37.75 12.5V0Z"
      fill="white"
    />
    <path
      d="M18.3988 45.3738H15.8513V43.7671H18.3988C18.7925 43.7671 19.1129 43.703 19.3601 43.5748C19.6073 43.442 19.7881 43.2589 19.9026 43.0255C20.017 42.792 20.0742 42.5288 20.0742 42.2358C20.0742 41.9383 20.017 41.6613 19.9026 41.405C19.7881 41.1487 19.6073 40.9427 19.3601 40.787C19.1129 40.6314 18.7925 40.5536 18.3988 40.5536H16.5655V48.9375H14.5055V38.9399H18.3988C19.1816 38.9399 19.8522 39.0818 20.4107 39.3657C20.9737 39.6449 21.404 40.0317 21.7016 40.5261C21.9991 41.0205 22.1479 41.5858 22.1479 42.2221C22.1479 42.8676 21.9991 43.426 21.7016 43.8975C21.404 44.369 20.9737 44.7329 20.4107 44.9893C19.8522 45.2456 19.1816 45.3738 18.3988 45.3738ZM27.4625 45.3738H24.9151V43.7671H27.4625C27.8562 43.7671 28.1766 43.703 28.4238 43.5748C28.671 43.442 28.8518 43.2589 28.9663 43.0255C29.0807 42.792 29.1379 42.5288 29.1379 42.2358C29.1379 41.9383 29.0807 41.6613 28.9663 41.405C28.8518 41.1487 28.671 40.9427 28.4238 40.787C28.1766 40.6314 27.8562 40.5536 27.4625 40.5536H25.6292V48.9375H23.5692V38.9399H27.4625C28.2453 38.9399 28.9159 39.0818 29.4744 39.3657C30.0374 39.6449 30.4677 40.0317 30.7653 40.5261C31.0628 41.0205 31.2116 41.5858 31.2116 42.2221C31.2116 42.8676 31.0628 43.426 30.7653 43.8975C30.4677 44.369 30.0374 44.7329 29.4744 44.9893C28.9159 45.2456 28.2453 45.3738 27.4625 45.3738ZM37.103 38.9399V48.9375H35.05V38.9399H37.103ZM40.1792 38.9399V40.5536H32.0219V38.9399H40.1792ZM43.0494 38.9399L44.9308 42.4281L46.8122 38.9399H49.1674L46.2629 43.8975L49.2429 48.9375H46.8671L44.9308 45.3807L42.9944 48.9375H40.6049L43.5918 43.8975L40.6805 38.9399H43.0494Z"
      fill="#0B0B0B"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7251_23358"
        x1="31.5"
        y1="0"
        x2="31.5"
        y2="62.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E7A370" />
        <stop offset="1" stopColor="#ECB88E" />
      </linearGradient>
    </defs>
  </svg>
);

export const SVGIcon = (
  <svg
    width="63"
    height="63"
    viewBox="0 0 63 63"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.75 6.25C6.75 2.79822 9.54822 0 13 0H38L56.75 18.75V56.25C56.75 59.7018 53.9518 62.5 50.5 62.5H13C9.54822 62.5 6.75 59.7018 6.75 56.25V6.25Z"
      fill="url(#paint0_linear_7251_23367)"
    />
    <path
      opacity="0.3"
      d="M38 0L56.75 18.75H44.25C40.7982 18.75 38 15.9518 38 12.5V0Z"
      fill="white"
    />
    <path
      d="M24.1763 46.3214C24.1763 46.1429 24.1488 45.9826 24.0939 45.8407C24.0435 45.6942 23.9474 45.5615 23.8055 45.4425C23.6636 45.3189 23.4645 45.1976 23.2081 45.0786C22.9518 44.9595 22.6199 44.8359 22.2125 44.7078C21.7593 44.5613 21.329 44.3965 20.9216 44.2134C20.5188 44.0303 20.1617 43.8174 19.8504 43.5748C19.5437 43.3276 19.3011 43.0415 19.1226 42.7165C18.9486 42.3915 18.8617 42.0138 18.8617 41.5835C18.8617 41.167 18.9532 40.7893 19.1363 40.4506C19.3194 40.1072 19.5758 39.8143 19.9054 39.5717C20.235 39.3245 20.6241 39.1345 21.0727 39.0017C21.5258 38.869 22.0225 38.8026 22.5627 38.8026C23.2997 38.8026 23.9428 38.9354 24.4922 39.2009C25.0415 39.4664 25.4672 39.8303 25.7693 40.2926C26.076 40.755 26.2294 41.2837 26.2294 41.8788H24.1832C24.1832 41.5858 24.1214 41.3295 23.9978 41.1097C23.8788 40.8854 23.6956 40.7092 23.4485 40.581C23.2058 40.4529 22.8991 40.3888 22.5284 40.3888C22.1713 40.3888 21.8737 40.4437 21.6357 40.5536C21.3977 40.6588 21.2191 40.803 21.1001 40.9861C20.9811 41.1647 20.9216 41.3661 20.9216 41.5904C20.9216 41.7598 20.9628 41.9131 21.0452 42.0504C21.1322 42.1878 21.2603 42.3159 21.4297 42.435C21.5991 42.554 21.8074 42.6661 22.0546 42.7714C22.3018 42.8767 22.5879 42.9797 22.9129 43.0804C23.4576 43.2452 23.936 43.4306 24.348 43.6366C24.7645 43.8426 25.1124 44.0738 25.3917 44.3301C25.6709 44.5865 25.8815 44.8771 26.0234 45.2021C26.1653 45.5272 26.2362 45.8957 26.2362 46.3076C26.2362 46.7425 26.1516 47.1316 25.9822 47.4749C25.8128 47.8183 25.5679 48.1089 25.2475 48.347C24.927 48.585 24.5448 48.7658 24.1008 48.8894C23.6567 49.013 23.1601 49.0748 22.6107 49.0748C22.1164 49.0748 21.6288 49.0107 21.1482 48.8826C20.6675 48.7498 20.2304 48.5507 19.8367 48.2852C19.4476 48.0197 19.1363 47.6809 18.9029 47.269C18.6694 46.857 18.5527 46.3694 18.5527 45.8064H20.6195C20.6195 46.1177 20.6675 46.3809 20.7637 46.596C20.8598 46.8112 20.9948 46.9851 21.1688 47.1179C21.3473 47.2506 21.5579 47.3468 21.8005 47.4063C22.0477 47.4658 22.3178 47.4955 22.6107 47.4955C22.9678 47.4955 23.2608 47.4452 23.4897 47.3445C23.7231 47.2438 23.8948 47.1042 24.0046 46.9256C24.1191 46.7471 24.1763 46.5457 24.1763 46.3214ZM31.2419 46.8501L33.5971 38.9399H35.8905L32.4092 48.9375H30.8986L31.2419 46.8501ZM29.0721 38.9399L31.4204 46.8501L31.7775 48.9375H30.2531L26.7924 38.9399H29.0721ZM44.6521 43.7121V47.6741C44.4964 47.8618 44.2561 48.0655 43.9311 48.2852C43.6061 48.5003 43.1872 48.6857 42.6745 48.8414C42.1618 48.997 41.5416 49.0748 40.8137 49.0748C40.1683 49.0748 39.58 48.9695 39.049 48.759C38.518 48.5438 38.0603 48.2303 37.6758 47.8183C37.2958 47.4063 37.0028 46.9027 36.7968 46.3076C36.5909 45.708 36.4879 45.0236 36.4879 44.2546V43.6297C36.4879 42.8607 36.5863 42.1763 36.7831 41.5767C36.9845 40.977 37.2706 40.4712 37.6414 40.0592C38.0122 39.6472 38.4539 39.3336 38.9666 39.1185C39.4793 38.9033 40.0493 38.7957 40.6764 38.7957C41.5461 38.7957 42.2603 38.9377 42.8187 39.2215C43.3772 39.5007 43.8029 39.8898 44.0959 40.3888C44.3934 40.8831 44.5765 41.4508 44.6452 42.0916H42.6471C42.5967 41.7529 42.5006 41.4576 42.3587 41.2059C42.2168 40.9541 42.0131 40.7573 41.7476 40.6154C41.4866 40.4734 41.1479 40.4025 40.7313 40.4025C40.388 40.4025 40.0813 40.4734 39.8112 40.6154C39.5457 40.7527 39.3214 40.9564 39.1383 41.2265C38.9552 41.4966 38.8156 41.8307 38.7195 42.229C38.6233 42.6272 38.5753 43.0896 38.5753 43.616V44.2546C38.5753 44.7764 38.6256 45.2388 38.7263 45.6416C38.827 46.0399 38.9758 46.3763 39.1726 46.651C39.3741 46.9211 39.6212 47.1248 39.9142 47.2621C40.2072 47.3994 40.5482 47.4681 40.9373 47.4681C41.2623 47.4681 41.5324 47.4406 41.7476 47.3857C41.9673 47.3307 42.1435 47.2644 42.2763 47.1866C42.4136 47.1042 42.5189 47.0263 42.5921 46.9531V45.1815H40.7107V43.7121H44.6521Z"
      fill="#0B0B0B"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7251_23367"
        x1="31.75"
        y1="0"
        x2="31.75"
        y2="62.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E7A370" />
        <stop offset="1" stopColor="#ECB88E" />
      </linearGradient>
    </defs>
  </svg>
);

export const TIFFIcon = (
  <svg
    width="63"
    height="63"
    viewBox="0 0 63 63"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.75 6.25C6.75 2.79822 9.54822 0 13 0H38L56.75 18.75V56.25C56.75 59.7018 53.9518 62.5 50.5 62.5H13C9.54822 62.5 6.75 59.7018 6.75 56.25V6.25Z"
      fill="url(#paint0_linear_7251_23376)"
    />
    <path
      opacity="0.3"
      d="M38 0L56.75 18.75H44.25C40.7982 18.75 38 15.9518 38 12.5V0Z"
      fill="white"
    />
    <path
      d="M22.9747 38.9399V48.9375H20.9216V38.9399H22.9747ZM26.0508 38.9399V40.5536H17.8935V38.9399H26.0508ZM29.4154 38.9399V48.9375H27.3623V38.9399H29.4154ZM33.4048 38.9399V48.9375H31.3449V38.9399H33.4048ZM37.3874 43.2109V44.8176H32.8418V43.2109H37.3874ZM37.868 38.9399V40.5536H32.8418V38.9399H37.868ZM41.1227 38.9399V48.9375H39.0628V38.9399H41.1227ZM45.1053 43.2109V44.8176H40.5597V43.2109H45.1053ZM45.5859 38.9399V40.5536H40.5597V38.9399H45.5859Z"
      fill="#0B0B0B"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7251_23376"
        x1="31.75"
        y1="0"
        x2="31.75"
        y2="62.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E7A370" />
        <stop offset="1" stopColor="#ECB88E" />
      </linearGradient>
    </defs>
  </svg>
);

export const TXTIcon = (
  <svg
    width="63"
    height="64"
    viewBox="0 0 63 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.75 7C6.75 3.54822 9.54822 0.75 13 0.75H38L56.75 19.5V57C56.75 60.4518 53.9518 63.25 50.5 63.25H13C9.54822 63.25 6.75 60.4518 6.75 57V7Z"
      fill="url(#paint0_linear_7251_23366)"
    />
    <path
      opacity="0.3"
      d="M38 0.75L56.75 19.5H44.25C40.7982 19.5 38 16.7018 38 13.25V0.75Z"
      fill="white"
    />
    <path
      d="M23.9291 39.6899V49.6875H21.876V39.6899H23.9291ZM27.0053 39.6899V41.3036H18.8479V39.6899H27.0053ZM29.8755 39.6899L31.7569 43.1781L33.6383 39.6899H35.9935L33.089 44.6475L36.069 49.6875H33.6932L31.7569 46.1307L29.8205 49.6875H27.431L30.4179 44.6475L27.5065 39.6899H29.8755ZM41.5759 39.6899V49.6875H39.5228V39.6899H41.5759ZM44.6521 39.6899V41.3036H36.4947V39.6899H44.6521Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7251_23366"
        x1="31.75"
        y1="0.75"
        x2="31.75"
        y2="63.25"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0F2830" />
        <stop offset="1" stopColor="#014751" />
      </linearGradient>
    </defs>
  </svg>
);

export const WEBPIcon = (
  <svg
    width="63"
    height="63"
    viewBox="0 0 63 63"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.25 6.25C6.25 2.79822 9.04822 0 12.5 0H37.5L56.25 18.75V56.25C56.25 59.7018 53.4518 62.5 50 62.5H12.5C9.04822 62.5 6.25 59.7018 6.25 56.25V6.25Z"
      fill="url(#paint0_linear_7251_23362)"
    />
    <path
      opacity="0.3"
      d="M37.5 0L56.25 18.75H43.75C40.2982 18.75 37.5 15.9518 37.5 12.5V0Z"
      fill="white"
    />
    <path
      d="M15.4228 47.3513L17.4141 38.9399H18.5265L18.7805 40.3407L16.6588 48.9375H15.464L15.4228 47.3513ZM14.3997 38.9399L16.0477 47.3513L15.9103 48.9375H14.5782L12.3604 38.9399H14.3997ZM20.5315 47.317L22.1588 38.9399H24.1982L21.9872 48.9375H20.6551L20.5315 47.317ZM19.1513 38.9399L21.1563 47.3857L21.1014 48.9375H19.9066L17.7711 40.3338L18.0458 38.9399H19.1513ZM32.0259 47.3307V48.9375H26.7044V47.3307H32.0259ZM27.3773 38.9399V48.9375H25.3174V38.9399H27.3773ZM31.3324 43.0117V44.5773H26.7044V43.0117H31.3324ZM32.019 38.9399V40.5536H26.7044V38.9399H32.019ZM37.1414 44.5498H34.5734L34.5596 43.1353H36.7157C37.0956 43.1353 37.4069 43.0873 37.6495 42.9911C37.8922 42.8904 38.073 42.7462 38.192 42.5586C38.3156 42.3663 38.3774 42.1328 38.3774 41.8582C38.3774 41.5469 38.3179 41.2951 38.1989 41.1029C38.0844 40.9106 37.9036 40.771 37.6564 40.684C37.4138 40.597 37.1002 40.5536 36.7157 40.5536H35.2875V48.9375H33.2275V38.9399H36.7157C37.2971 38.9399 37.8166 38.9949 38.2744 39.1047C38.7367 39.2146 39.1281 39.3817 39.4485 39.606C39.769 39.8303 40.0139 40.1141 40.1833 40.4574C40.3526 40.7962 40.4373 41.199 40.4373 41.6659C40.4373 42.0779 40.3435 42.4579 40.1558 42.8058C39.9727 43.1537 39.682 43.4375 39.2838 43.6572C38.8901 43.8769 38.3751 43.9982 37.7388 44.0211L37.1414 44.5498ZM37.0522 48.9375H34.0103L34.8137 47.3307H37.0522C37.4138 47.3307 37.709 47.2735 37.9379 47.1591C38.1668 47.0401 38.3362 46.8799 38.446 46.6784C38.5559 46.477 38.6108 46.2458 38.6108 45.9849C38.6108 45.692 38.5605 45.4379 38.4598 45.2227C38.3636 45.0076 38.208 44.8428 37.9929 44.7284C37.7777 44.6093 37.4939 44.5498 37.1414 44.5498H35.157L35.1707 43.1353H37.6427L38.1165 43.6915C38.7253 43.6824 39.2151 43.7899 39.5859 44.0143C39.9612 44.234 40.2336 44.5201 40.403 44.8726C40.5769 45.225 40.6639 45.6027 40.6639 46.0055C40.6639 46.6464 40.5243 47.1866 40.2451 47.626C39.9658 48.0609 39.5561 48.3882 39.016 48.6079C38.4804 48.8276 37.8258 48.9375 37.0522 48.9375ZM46.1021 45.3738H43.5547V43.7671H46.1021C46.4958 43.7671 46.8163 43.703 47.0634 43.5748C47.3106 43.442 47.4915 43.2589 47.6059 43.0255C47.7203 42.792 47.7776 42.5288 47.7776 42.2358C47.7776 41.9383 47.7203 41.6613 47.6059 41.405C47.4915 41.1487 47.3106 40.9427 47.0634 40.787C46.8163 40.6314 46.4958 40.5536 46.1021 40.5536H44.2688V48.9375H42.2089V38.9399H46.1021C46.8849 38.9399 47.5555 39.0818 48.114 39.3657C48.6771 39.6449 49.1074 40.0317 49.4049 40.5261C49.7025 41.0205 49.8512 41.5858 49.8512 42.2221C49.8512 42.8676 49.7025 43.426 49.4049 43.8975C49.1074 44.369 48.6771 44.7329 48.114 44.9893C47.5555 45.2456 46.8849 45.3738 46.1021 45.3738Z"
      fill="#0B0B0B"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7251_23362"
        x1="31.25"
        y1="0"
        x2="31.25"
        y2="62.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E7A370" />
        <stop offset="1" stopColor="#ECB88E" />
      </linearGradient>
    </defs>
  </svg>
);

export const XLSIcon = (
  <svg
    width="63"
    height="64"
    viewBox="0 0 63 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.25 7C6.25 3.54822 9.04822 0.75 12.5 0.75H37.5L56.25 19.5V57C56.25 60.4518 53.4518 63.25 50 63.25H12.5C9.04822 63.25 6.25 60.4518 6.25 57V7Z"
      fill="url(#paint0_linear_7251_23372)"
    />
    <path
      opacity="0.3"
      d="M37.5 0.75L56.25 19.5H43.75C40.2982 19.5 37.5 16.7018 37.5 13.25V0.75Z"
      fill="#0B0B0B"
    />
    <path
      d="M21.2387 39.6899L23.1201 43.1781L25.0015 39.6899H27.3567L24.4522 44.6475L27.4323 49.6875H25.0565L23.1201 46.1307L21.1838 49.6875H18.7943L21.7812 44.6475L18.8698 39.6899H21.2387ZM34.8961 48.0807V49.6875H29.863V48.0807H34.8961ZM30.529 39.6899V49.6875H28.4691V39.6899H30.529ZM41.2819 47.0714C41.2819 46.8929 41.2544 46.7326 41.1995 46.5907C41.1491 46.4442 41.053 46.3115 40.9111 46.1925C40.7692 46.0689 40.5701 45.9476 40.3137 45.8286C40.0574 45.7095 39.7255 45.5859 39.3181 45.4578C38.8649 45.3113 38.4346 45.1465 38.0272 44.9634C37.6244 44.7803 37.2673 44.5674 36.956 44.3248C36.6493 44.0776 36.4067 43.7915 36.2282 43.4665C36.0542 43.1415 35.9673 42.7638 35.9673 42.3335C35.9673 41.917 36.0588 41.5393 36.2419 41.2006C36.425 40.8572 36.6814 40.5643 37.011 40.3217C37.3405 40.0745 37.7296 39.8845 38.1783 39.7517C38.6314 39.619 39.1281 39.5526 39.6683 39.5526C40.4053 39.5526 41.0484 39.6854 41.5977 39.9509C42.1471 40.2164 42.5728 40.5803 42.8749 41.0426C43.1816 41.505 43.335 42.0337 43.335 42.6288H41.2888C41.2888 42.3358 41.227 42.0795 41.1034 41.8597C40.9843 41.6354 40.8012 41.4592 40.554 41.331C40.3114 41.2029 40.0047 41.1388 39.6339 41.1388C39.2769 41.1388 38.9793 41.1937 38.7413 41.3036C38.5033 41.4088 38.3247 41.553 38.2057 41.7361C38.0867 41.9147 38.0272 42.1161 38.0272 42.3404C38.0272 42.5098 38.0684 42.6631 38.1508 42.8004C38.2378 42.9378 38.3659 43.0659 38.5353 43.185C38.7047 43.304 38.913 43.4161 39.1602 43.5214C39.4073 43.6267 39.6935 43.7297 40.0185 43.8304C40.5632 43.9952 41.0416 44.1806 41.4536 44.3866C41.8701 44.5926 42.218 44.8238 42.4973 45.0801C42.7765 45.3365 42.9871 45.6271 43.129 45.9521C43.2709 46.2772 43.3418 46.6457 43.3418 47.0576C43.3418 47.4925 43.2571 47.8816 43.0878 48.2249C42.9184 48.5683 42.6735 48.8589 42.3531 49.097C42.0326 49.335 41.6504 49.5158 41.2064 49.6394C40.7623 49.763 40.2657 49.8248 39.7163 49.8248C39.222 49.8248 38.7344 49.7607 38.2538 49.6326C37.7731 49.4998 37.336 49.3007 36.9423 49.0352C36.5532 48.7697 36.2419 48.4309 36.0085 48.019C35.775 47.607 35.6583 47.1194 35.6583 46.5564H37.7251C37.7251 46.8677 37.7731 47.1309 37.8693 47.346C37.9654 47.5612 38.1004 47.7351 38.2744 47.8679C38.4529 48.0006 38.6635 48.0968 38.9061 48.1563C39.1533 48.2158 39.4234 48.2455 39.7163 48.2455C40.0734 48.2455 40.3664 48.1952 40.5952 48.0945C40.8287 47.9938 41.0004 47.8542 41.1102 47.6756C41.2247 47.4971 41.2819 47.2957 41.2819 47.0714Z"
      fill="#0B0B0B"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7251_23372"
        x1="57.8629"
        y1="89.9032"
        x2="-20.8749"
        y2="48.924"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#AFF8C8" />
        <stop offset="1" stopColor="#6E8F95" />
      </linearGradient>
    </defs>
  </svg>
);

export const XLSXIcon = (
  <svg
    width="63"
    height="64"
    viewBox="0 0 63 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.25 7C6.25 3.54822 9.04822 0.75 12.5 0.75H37.5L56.25 19.5V57C56.25 60.4518 53.4518 63.25 50 63.25H12.5C9.04822 63.25 6.25 60.4518 6.25 57V7Z"
      fill="url(#paint0_linear_7251_23360)"
    />
    <path
      opacity="0.3"
      d="M37.5 0.75L56.25 19.5H43.75C40.2982 19.5 37.5 16.7018 37.5 13.25V0.75Z"
      fill="#0B0B0B"
    />
    <path
      d="M16.7755 39.6899L18.6569 43.1781L20.5383 39.6899H22.8935L19.989 44.6475L22.9691 49.6875H20.5933L18.6569 46.1307L16.7206 49.6875H14.3311L17.318 44.6475L14.4066 39.6899H16.7755ZM30.4329 48.0807V49.6875H25.3998V48.0807H30.4329ZM26.0658 39.6899V49.6875H24.0059V39.6899H26.0658ZM36.8187 47.0714C36.8187 46.8929 36.7912 46.7326 36.7363 46.5907C36.6859 46.4442 36.5898 46.3115 36.4479 46.1925C36.306 46.0689 36.1069 45.9476 35.8505 45.8286C35.5942 45.7095 35.2623 45.5859 34.8549 45.4578C34.4017 45.3113 33.9714 45.1465 33.564 44.9634C33.1612 44.7803 32.8041 44.5674 32.4928 44.3248C32.1861 44.0776 31.9435 43.7915 31.765 43.4665C31.591 43.1415 31.5041 42.7638 31.5041 42.3335C31.5041 41.917 31.5956 41.5393 31.7787 41.2006C31.9618 40.8572 32.2182 40.5643 32.5478 40.3217C32.8773 40.0745 33.2664 39.8845 33.7151 39.7517C34.1682 39.619 34.6649 39.5526 35.2051 39.5526C35.9421 39.5526 36.5852 39.6854 37.1346 39.9509C37.6839 40.2164 38.1096 40.5803 38.4117 41.0426C38.7184 41.505 38.8718 42.0337 38.8718 42.6288H36.8256C36.8256 42.3358 36.7638 42.0795 36.6402 41.8597C36.5211 41.6354 36.338 41.4592 36.0909 41.331C35.8482 41.2029 35.5415 41.1388 35.1707 41.1388C34.8137 41.1388 34.5161 41.1937 34.2781 41.3036C34.0401 41.4088 33.8615 41.553 33.7425 41.7361C33.6235 41.9147 33.564 42.1161 33.564 42.3404C33.564 42.5098 33.6052 42.6631 33.6876 42.8004C33.7746 42.9378 33.9027 43.0659 34.0721 43.185C34.2415 43.304 34.4498 43.4161 34.697 43.5214C34.9442 43.6267 35.2303 43.7297 35.5553 43.8304C36.1 43.9952 36.5784 44.1806 36.9904 44.3866C37.4069 44.5926 37.7548 44.8238 38.0341 45.0801C38.3133 45.3365 38.5239 45.6271 38.6658 45.9521C38.8077 46.2772 38.8786 46.6457 38.8786 47.0576C38.8786 47.4925 38.7939 47.8816 38.6246 48.2249C38.4552 48.5683 38.2103 48.8589 37.8899 49.097C37.5694 49.335 37.1872 49.5158 36.7432 49.6394C36.2991 49.763 35.8025 49.8248 35.2531 49.8248C34.7588 49.8248 34.2712 49.7607 33.7906 49.6326C33.3099 49.4998 32.8728 49.3007 32.4791 49.0352C32.09 48.7697 31.7787 48.4309 31.5453 48.019C31.3118 47.607 31.1951 47.1194 31.1951 46.5564H33.2619C33.2619 46.8677 33.3099 47.1309 33.4061 47.346C33.5022 47.5612 33.6372 47.7351 33.8112 47.8679C33.9897 48.0006 34.2003 48.0968 34.4429 48.1563C34.6901 48.2158 34.9602 48.2455 35.2531 48.2455C35.6102 48.2455 35.9032 48.1952 36.132 48.0945C36.3655 47.9938 36.5372 47.8542 36.647 47.6756C36.7615 47.4971 36.8187 47.2957 36.8187 47.0714ZM41.9754 39.6899L43.8568 43.1781L45.7382 39.6899H48.0934L45.1889 44.6475L48.1689 49.6875H45.7932L43.8568 46.1307L41.9205 49.6875H39.5309L42.5179 44.6475L39.6065 39.6899H41.9754Z"
      fill="#0B0B0B"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7251_23360"
        x1="57.8629"
        y1="89.9032"
        x2="-20.8749"
        y2="48.924"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#AFF8C8" />
        <stop offset="1" stopColor="#6E8F95" />
      </linearGradient>
    </defs>
  </svg>
);
